<template>
    <div class="modal-body-detail-row">
        <a :href="link" class="d-flex align-items-center">{{ title }}</a>
    </div>
</template>

<script>
    export default {
        props: {
            title: String,
            link: String
        }
    }
</script>

<style lang="sass" scoped>
    @mixin arrow-right-position($color:rgba(0, 0, 0, 0.24), $rotate:45deg, $margin-top:0, $right:18px)
        position: relative
        display: inline-block
        &::after
            content: ''
            width: 10px
            height: 10px
            border: 0px
            border-top: solid 2px $color
            border-right: solid 2px $color
            -ms-transform: rotate($rotate)
            -webkit-transform: rotate($rotate)
            transform: rotate($rotate)
            position: absolute
            top: 50%
            right: $right
            margin-top: $margin-top

    .modal-body-detail-row
        padding: 12px
        border-bottom: solid 1px rgba(0, 0, 0, 0.08)
        transition: .2s
        &:hover
            background-color: #eee
    a
        @include arrow-right-position(rgba(0, 0, 0, 0.24), 45deg, -4px)

</style>